//import { createStore } from "vuex";
import Vue from "vue";
import Vuex, { Store } from "vuex";

Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate";
//import { productsData } from "../firebase";
import firebase from "firebase";  
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";    


// firebase init
var firebaseConfig = {
apiKey: "AIzaSyAdBemRNhTl03e60BGZp52uiRDMU8-aEtA",
authDomain: "sendsoko.firebaseapp.com",
databaseURL: "https://sendsoko.firebaseio.com",
projectId: "sendsoko",
storageBucket: "sendsoko.appspot.com",
messagingSenderId: "46946369363",
appId: "1:46946369363:web:035930e8a8d905f142aba6",
measurementId: "G-PVJ8XZZN8B"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const dbRef = firebase.database().ref();

var productRef = firebaseApp.database().ref("message");

var usersRef = firebaseApp.database().ref("userDetails");
var ordersRef = firebaseApp.database().ref("Orders");
var shopRef = firebaseApp.database().ref("Users");
var categoriesRef = firebaseApp.database().ref("menus");
var transactionRef = firebaseApp.database().ref("transactions"); 
var paymentsRef = firebaseApp.database().ref("Payments");


const writeUserData = (userId, name, email) =>{
firebase.database().ref('users/' + userId).set({
  username: name,
  email: email
});
}

const saveUserDetails = (user) => {
var userId = usersRef.push().key;
firebaseApp.database().ref("userDetails/"+userId).set(user);
}


//instrucctions
/*
- create a state to hold products
- create mutation to set product a
- create action to dounload the product 

-------------
todos
- copy all firebase data and methods from the firebase module 
- Console log all data 
- test on ui

* 
*/
 
export default new Vuex.Store({
state: {
  count: 0,
  products: [],
  currProduct: [],
  categories: [],
  curr: [],
  currentShop: [],
  currentShopProducts: [],
  currCategory:"",
  similar: [],
  currentCategoryList:[],
  loggedInUser:[],
  currentUserOrders:[],
  loggedIn: false,
  logState: "false",
  loggedInEmail: '',
  loggedInName: '',

  
  user: {
    firstName: '',
    lastName: '',
    phoneNumber:'',
    emailAddress:'',
    password: '', 
    buyerLocation: []
  },
  currId: "",
  transactions: []
},

mutations: {
  adder(state) {
    state.count = 4089;
  },
  setCurr(state, key) {
    //  state.curr = key;

    console.log("current object is" + state.products[key]); // 'Bob', 47
    state.currProduct = state.products[key];
  },
  setCurrentShop(state,key)
  {


   
dbRef.child("Users").child(key).get().then((snapshot) => {
if (snapshot.exists()) {
  console.log("Current shop is:"+snapshot.val());

  state.currentShop = snapshot.val();
  console.log(state.currentShop.name);


} else {
  console.log("No data available");
}
}).catch((error) => {
console.error(error);
});




  },



  /* Get shop products  */

  setCurrentShopProducts(state)
  {
var products = [];
  
       
      console.log("current shop state data "+ state.currentShopProducts);
 
      productRef.orderByChild("userPhoneNumber").equalTo(state.currentShop.phoneNumber).on("child_added", function(snapshot) {
        console.log("confirmation of new query"+snapshot.key);
        var key = snapshot.key;
        var data = snapshot.val();
        products.push({ key: key, data: data });
      });
      state.currentShopProducts = products;
      
  },


  /** end of fetching products  */


  setCurrentCategoryList(state,categoryName){
    state.currCategory = categoryName;
    state.currentCategoryList = state.products.filter(
      product => product.data.itemCategory === state.currCategory );
    
  },

  setLoggedInUser(state,user){
state.loggedInUser = user;
  },
setUserOrders(state,orders){
  state.currentUserOrders = orders;
},
  setUser(state,user) {

    state.user =  user;
    var userId = usersRef.push().key;
firebaseApp.database().ref("userDetails/"+userId).set(user);

    // saveUserDetails(state.user);
      },

      saveTransactionRecord(state,transactionRecord) {
      var transactionId = transactionRef.push().key;  
      if(!transactionRecord.redirectstatus )
      {
        transactionRecord.redirectstatus = "Value not registered";
      }
      firebaseApp.database().ref("transactions/"+transactionId).set(transactionRecord);
      },

      

  setId(state, myId) {
    state.currId = myId;
    console.log("current item" + state.currId);
    state.curr = state.products.find(product => product.key === state.currId);
    state.similar = state.products.filter(
      product => product.data.itemCategory === state.curr.data.itemCategory
    );
    //state.curr = state.products.find(product => key === myId);
    console.log(state.curr);
  },

  setProducts(state, products) {
    state.products = products;
  },

  setTransactions(state, transactions){
    state.transactions = transactions;
  },
  setCategories(state, categories) {
    state.categories = categories;
  }
},
actions: {

  authenticateUserPhone() {

    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      'size': 'normal',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      },
      'expired-callback': () => {
        // Response expired. Ask user to solve reCAPTCHA again.
        // ...
      }
    });
    recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
    const recaptchaResponse = grecaptcha.getResponse(recaptchaWidgetId);

    const appVerifier = window.recaptchaVerifier;

    
   // const phoneNumber = getPhoneNumberFromUserInput(); 
firebase.auth().signInWithPhoneNumber("+254701245574", appVerifier)
    .then((confirmationResult) => {
      // SMS sent. Prompt user to type the code from the message, then sign the
      // user in with confirmationResult.confirm(code).
      window.confirmationResult = confirmationResult;
      // ...
    }).catch((error) => {
      // Error; SMS not sent
      // ...
console.log(error);
      grecaptcha.reset(window.recaptchaWidgetId);

// Or, if you haven't stored the widget ID:
window.recaptchaVerifier.render().then(function(widgetId) {
  grecaptcha.reset(widgetId);
});
    });


  },
   getCurrentUser(state,commit) {
     //get firebase data
     var user = [];

   

    // console.log("my Products" + products);

    usersRef.orderByChild("emailAddress").equalTo(this.state.loggedInEmail).once("value",function(snapshot){
      snapshot.forEach(function(childSnapshot) {
        var key = childSnapshot.key;
        var data = childSnapshot.val(); 
        user.push({ key:key, data: data})
        
      });
     
    });

    this.commit("setLoggedInUser",user)
    console.log(user);
    
   //var userEmail = this.state.loggedInEmail;
 /*
    usersRef.orderByChild("emailAddress").equalTo(userEmail).on("child_added", function(Data){
    console.log(Data.val(), Data.key);
    user.push({Data: data,key: key})
  

    });
    commit("setLoggedInUser",user);
*/
   },

   getUserOrders(){
    var orders = [];
    // console.log("my Products" + products);

    ordersRef.orderByChild("buyerNumber").equalTo("+254701245574").once("value",function(snapshot){
      snapshot.forEach(function(childSnapshot) {
        var key = childSnapshot.key;
        var data = childSnapshot.val(); 
        orders.push({ key:key, data: data})
        
      });
     
    });

    this.commit("setUserOrders",orders)
    //alert("downloading orders ... "+orders);
    
   },

  authenticateUserEmailAndPassword(state,user,res,errorVal) {

    console.log("clicked!"); 
    alert("auth reached!"+user.emailAddress+ user.password);

    
    return new Promise((resolve, reject) => {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  .then(() => {

    firebase.auth().signInWithEmailAndPassword(user.emailAddress,user.password).then((credential) => {
       

      state.loggedIn = true;
      state.loggedInEmail = user.emailAddress; 
      state.logState = "true";
      console.log("the loggedin user is: " + user.password+ user.emailAddress);
      console.log("the logged i sate is:"+ state.logState );
       
    //  alert('logedinUser is :' + state.loggedInEmail);

    

    res = user.emailAddress;

resolve(res);

    // ...
  })
  .catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;

    console.log("Error with email and password login: "+ "errorCode: " + errorCode + "errorMessage: " + errorMessage) ;
   errorVal = errorMessage;
    reject(errorVal);
    // ..
  });
    
}) .catch((error) => {
  // Handle Errors here.
  const errorCode = error.code;
  const errorMessage = error.message;
});
    });

    
  },

signupWithEmailAndPassword(state, user,res,errorVal) {

  return new Promise((resolve, reject) => {


  firebase.auth().createUserWithEmailAndPassword(user.emailAddress, user.phoneNumber)
  .then((userCredential) => {
    // Signed in 
    var authUser = userCredential.user; 
    state.loggedIn = true;
    console.log("The signedup in user is: "+ authUser);

    // create a user record 

    state.user =  user;
    var userId = usersRef.push().key;
firebaseApp.database().ref("userDetails/"+userId).set(user);
res = user.emailAddress;

resolve(res);

    // ...
  })
  .catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;

    console.log("Error during signup eith email and password. "+ "ErrorCode: "+ errorCode+ "errorMessage: "+ errorMessage);
    errorVal = errorMessage;
    reject(errorVal);
    // ..
  });

})
},

  authenticateUserGoogle(state,buyerLocation,res,errorVal) {

    return new Promise((resolve, reject) => {

    var provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
    
    firebase.auth()
  .signInWithPopup(provider)
  .then((result) => {
    /** @type {firebase.auth.OAuthCredential} */
    var credential = result.credential;
    var firstName = result.user.displayName.split(" ")[0];
    var lastName = result.user.displayName.split(" ")[1];
    var email = result.user.email;
  
 
    console.log("Sign Creds :"+ JSON.stringify(credential));
    console.log("User dets :"+ JSON.stringify(result.user));
    console.log("Email: "+ email);
    console.log("First Name: "+ firstName);
    console.log("Last Name: "+ lastName);

var user = {
  firstName: firstName,
  lastName: lastName,
  emailAddress: email,
  buyerLocation: buyerLocation

}
    state.user =  user;
    var userId = usersRef.push().key;
firebaseApp.database().ref("userDetails/"+userId).set(user);
   
    // This gives you a Google Access Token. You can use it to access the Google API.
 
    // The signed-in user info.
    var user = result.user;
    state.loggedIn = true;
    console.log("User Info :"+ user );
    return "success google login";
    // ...
  }).catch((error) => {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    console.log("Login Error :"+ error);
    // ...
  });

  res = "Success!";
  resolve(res);
}) .catch((error) => {
  var errorCode = error.code;
  var errorMessage = error.message;

  console.log("Error during signup eith email and password. "+ "ErrorCode: "+ errorCode+ "errorMessage: "+ errorMessage);
  errorVal = errorMessage;
  reject(errorVal);
  // ..
});
      },


      checkAuthStatus(state,res,errorVal){

       
        return new Promise((resolve, reject) => {
          let status = "false";
          var that = state;
          var loggedInEmailVal = '';
          var loggedInUserVal = '';
          var logStateVal = '';

        firebase.auth().onAuthStateChanged(function(user) {
          if (user) {

            // User is signed in.
            console.log('User is loggedin => '+ user.email + 'Name =>'+ user.displayName); 
            
           
            
            
          loggedInEmailVal = user.email;
          loggedInUserVal = user.displayName;
          logStateVal = "true";
             
            
            res = logStateVal;
            resolve(res);
          
           
          } else {
            // User is not signed in.
            console.log('No logged in user!');
            logStateVal = "false";
            state.logState = "false";
            resolve(logStateVal)
            
          }
        });


        
      }).catch((error)=> {

        if(error != null){
         
        var errorMessage = error.message;
      }
        errorVal = errorMessage;
        reject(errorVal)
     
      })  
     
      }, 
  getProducts({ commit }) {
    var products = [];

    productRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        var key = childSnapshot.key;
        var data = childSnapshot.val();
        products.push({ key: key, data: data });
        //    console.log({ key: key, data: data });
      });
      commit("setProducts", products);
    });

    // console.log("my Products" + products);
  },

  getTransactions({commit}){

    var transactions = [];
    paymentsRef.once("value", function(snapshot){
      snapshot.forEach(function(childSnapshot){
        var key = childSnapshot.key;
        var data = childSnapshot.val();
        transactions.push({key:key,data:data});
      });

      transactions.sort(function(x, y){
        return x.data.timestamp - y.data.timestamp;
    })
      commit("setTransactions", transactions)
      console.log("transactions are here:"+transactions);
      
    })
  },

  doAdder({ commit }) {
    commit("adder");
  },
  getCurr({ commit }) {
    commit("setCurr");
  },
  getCategories({ commit }) {
    var categories = [];
    categoriesRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        var key = childSnapshot.key;
        var data = childSnapshot.val();
        categories.push({ key: key, data: data });
      });

      commit("setCategories", categories);
    });
  }
},
getters: {
  productList: state => {
    return state.products;
  },
  categoriesList: state => {
    return state.categories;
  },
  categoryProducts:state => {
    return state.currentCategoryList;
  },
  currentCategoryList:state => {
    return state.currentCategoryList;
  },
  transactionsList: state => {
    return state.transactions;
  }
},

modules: {},
plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store/index.js